import React from 'react';
import classnames from 'classnames';
import noop from 'lodash-es/noop';

import EmailAlertCircle from 'images/email-alert-circle.svg';
import ErrorAlertCircle from 'images/error-alert-circle.svg';
import AuthContainer from 'components/auth/auth-container';

import './email-notification.css';

interface EmailNotificationProps {
  className?: string;
  title: React.ReactNode;
  message?: React.ReactNode;
  error?: boolean;
  footerText?: React.ReactNode;
  linkText?: React.ReactNode;
  onClickLink?: () => void;
}

const EmailNotification = ({
  className = '',
  title,
  message = null,
  error = false,
  footerText = '',
  linkText = '',
  onClickLink = noop,
}: EmailNotificationProps): React.JSX.Element => (
  <AuthContainer isEmailNotification>
    <div className={classnames('email-notification', className)}>
      <div className="email-notification__center">
        <img
          src={error ? ErrorAlertCircle : EmailAlertCircle}
          alt={error ? 'Error Alert Circle' : 'Email Alert Circle'}
        />
      </div>
      <div className="email-notification__title">{title}</div>
      {message && <div className="email-notification__message">{message}</div>}
      {message && linkText && (
        <div className="email-notification__link-container">
          {footerText}
          <button type="button" className="email-notification__link" onClick={onClickLink}>
            {linkText}
          </button>
        </div>
      )}
    </div>
  </AuthContainer>
);

export default EmailNotification;
